import { ICoverageCoordinate } from 'stores/searchCoverage/types';

export interface ICoverageHistoryEntry {
  id: string;
  at: number;
  countryCode: string;
  phrases: string[];
  coordinates: ICoverageCoordinate[];
}

const KEY = 'searchCoverageHistory';
const MAX_ENTRIES = 10;

/** Reads experiment history from localStorage. Never throws — corrupt data yields []. */
export const loadCoverageHistory = (): ICoverageHistoryEntry[] => {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? (parsed as ICoverageHistoryEntry[]) : [];
  } catch {
    return [];
  }
};

/** Prepends an entry, caps the list at MAX_ENTRIES, persists, and returns the new list. */
export const addCoverageHistory = (
  entry: Omit<ICoverageHistoryEntry, 'id' | 'at'>,
  now: number
): ICoverageHistoryEntry[] => {
  const full: ICoverageHistoryEntry = { ...entry, id: String(now), at: now };
  const next = [full, ...loadCoverageHistory()].slice(0, MAX_ENTRIES);
  try {
    localStorage.setItem(KEY, JSON.stringify(next));
  } catch {
    // storage full / disabled — history is best-effort, ignore.
  }
  return next;
};

export const clearCoverageHistory = (): ICoverageHistoryEntry[] => {
  try {
    localStorage.removeItem(KEY);
  } catch {
    // ignore
  }
  return [];
};
